import React from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const Group = styled.g `
  animation: rotate 1s linear infinite;
  transform-origin: 50% 50%;

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const Circle = styled.circle `
  stroke-dasharray: 38px;
  stroke-dashoffset: 114px;
  animation: offset 2s linear infinite;

  @keyframes offset {
    50% {
      stroke-dashoffset: 96px;
    }
  }
`;
export const IconLoading = (props) => {
    return (React.createElement(IconBase, { ...props, viewportSize: 16 },
        React.createElement(Group, { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", style: { stroke: 'var(--icon-color)' } },
            React.createElement("circle", { strokeOpacity: ".2", cx: "8", cy: "8", r: "6" }),
            React.createElement(Circle, { cx: "8", cy: "8", r: "6" }))));
};
//# sourceMappingURL=Loading.js.map